import $ from "jquery";

$("#to-top").on("click", function() {
    $("html, body").animate({ scrollTop: 0 }, 100);
});
